<div
  class="user-warnings"
  [ngClass]="{ 'in-lcl-shipment': isInLclShipment, 'in-lcl-booking': isInLclBooking, 'in-lcl-quote': isInLclQuote }"
  *ngIf="isShowBatchReview || isShowMonthlyFailed"
>
  <app-month-bill-failed
    [organizationOrCompanyFailedBill]="companyFailedBill"
    (payNow)="payFailedBill()"
    *ngIf="isShowMonthlyFailed && !!companyFailedBill"
  ></app-month-bill-failed>

  <app-month-bill-failed
    [textTranslationKey]="isOrganizationMember ? 'ERROR_USER_CHANGE_ORGANIZATION_PAYMENT_METHOD' : 'ERROR_CHANGE_YOUR_PAYMENT_METHOD'"
    [organizationOrCompanyFailedBill]="organizationFailedBill"
    (payNow)="payFailedBill(true)"
    *ngIf="isShowMonthlyFailed && !!organizationFailedBill"
  ></app-month-bill-failed>

  <div class="d-none d-xl-block" *ngIf="isShowBatchReview">
    <app-batch-review *ngFor="let batchItem of filteredBatchItems" [batchItem]="batchItem"></app-batch-review>
  </div>
</div>
